<template>
  <!-- 跳转前的loading提示，可自定义 -->
  <div style="text-align:center;line-height:100vh;">
    页面适配中，请稍候...
  </div>
</template>

<script>
export default {
  name: "DeviceAdapt",
  // 页面创建时立刻执行适配判断
  created() {
    this.autoAdaptDevice();
  },
  methods: {
    autoAdaptDevice() {
      // 🔍 核心：判断是否为移动端（手机/平板）
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );

      // 你的两个适配链接
      const PC_URL = "https://www.hong1fo.com/hyj2026_pc/";
      const MOBILE_URL = "https://www.hong1fo.com/hyj2026_yd/";

      // 🚀 自动跳转
      window.location.href = isMobile ? MOBILE_URL : PC_URL;
    },
  },
};
</script>